export default __webpack_public_path__ + "static/media/guy-home.4f8fb61b.webp";